import React from "react";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import { RecommendationCaseChip } from "./RecommendationCaseChip";
import { RecommendationProductsTable } from "./RecommendationProductsTable";

export function RecommendationsPanel({ cards, selectedCase, onSelectCase, onClose }) {
    const selectedCard = cards.find((card) => card.case === selectedCase);

    return (
        <Drawer
            anchor="right"
            open={selectedCase !== null}
            onClose={onClose}
            classes={{ paper: "recommendations-panel" }}>
            <div className="recommendations-panel__header">
                <span className="recommendations-panel__title">Oportunidades detectadas</span>
                <button
                    className="recommendations-panel__close"
                    data-testid="recommendations-panel-close"
                    onClick={onClose}>
                    <CloseIcon />
                </button>
            </div>

            <div className="recommendations-panel__body">
                <aside className="recommendations-panel__cases">
                    {cards.map((card) => (
                        <button
                            key={card.case}
                            data-testid="recommendations-panel-case"
                            className={`recommendations-panel__case${
                                card.case === selectedCase
                                    ? " recommendations-panel__case--selected"
                                    : ""
                            }`}
                            onClick={() => onSelectCase(card.case)}>
                            <RecommendationCaseChip caseType={card.case} />
                            <span className="recommendations-panel__case-total">
                                {card.total} productos
                            </span>
                        </button>
                    ))}
                </aside>

                <div className="recommendations-panel__table">
                    {selectedCard && (
                        <RecommendationProductsTable
                            caseType={selectedCard.case}
                            products={selectedCard.products}
                        />
                    )}
                </div>
            </div>
        </Drawer>
    );
}
